export default __webpack_public_path__ + "static/media/selectbox-chevron.04607911.svg";